function setFollowingUser(userId, otherId, follow){
	$.ajax({
		data: {revent:'LW_FOLLOW_USER', userId: userId, otherId: otherId, follow: follow},
		success: function(response, textStatus, xhr) {
			window.location.href = window.location.href;
		}
	});
}


/**
 *	Inizializza il template [groupUserAssociationObject_BaseTMPL] 
 */
function initGroupUserAssociationTMPL(roleID, roleTagInit, mshPageId, refObjId, allowTagUser, allowTagAuthGroup, isSpecialSocialRole, isMultiRoleEnabled, isRoleAssignable, socialPageType) {
	$('#removeButton_'+roleID).button();
	$('#changeButton_'+roleID).button();
	
	var roleDecorators = [];
	if (allowTagUser && allowTagUser === 'true'){
		roleDecorators.push(AssigneeDecorator);
	}
	if(allowTagAuthGroup && allowTagAuthGroup === 'true'){
		roleDecorators.push(AuthGroupDecorator);
	}
	
	/**
	 * Trasforma in stringa il contenuto associato ai tagCollector con class roleCollector 
	 */
	function roleAssociationToString(dId, pId) {
		var result = "";
		$(".roleCollector").each(function(index) {
			
			var roleID = $(this).attr('id').split("_")[1];
			var roleTagInitJson = $(this).tagCollector('getJson',false);			
			
			if (typeof roleTagInitJson == "string") {
				roleTagInitJson = JSON.parse(roleTagInitJson);
			}
			for (var i=0; i<roleTagInitJson.text.length; i++) {
				var node = roleTagInitJson.text[i];
				var nodeDOM = $('.specialTag[uId="'+node.at.uId+'"]', $(this));
				if (!isRoleAssignable && node.at.removable!=='true'){
					nodeDOM.addClass('disabled');					
				}else{
					nodeDOM.removeClass('disabled');
				}
				if (node.t) {
					switch (node.t) {
						case "AUTH_GROUP":
							result += node.at.uId+"_0:"+roleID+",";
				        break;
						case "USER":
							result += node.at.uId+"_1:"+roleID+",";
				        break;
					}
				}				
			}
		});
		sendParamChanged(dId,pId,'SOCIAL_AREA_ROLES',result);
	}
	
	function sendParameter(attributes, role) {
		var $invocante = $(this);
		if (!isMultiRoleEnabled){ 			
			$(".roleCollector").each(function() {
	  			var $analizzato = $(this);	  		 			
	  			if (($invocante.attr("id") != $analizzato.attr("id"))) {
					$(this).tagCollector('removeTagNodeFromAttribute', attributes, role, false);
	    		}
			});
		}
	
		roleAssociationToString(mshPageId, refObjId);	
	}
  
	//editable a true
	var optCC = {
		decorators       : roleDecorators,
		draggable		 : 'edit',
   		draggableContext : '.rolesList',
   		editable		:  isRoleAssignable,
      	addTagNodeCallback : [sendParameter],
      	removeTagNodeCallback : [sendParameter]
	};
  
	var $ROLE = $("#ROLE_"+roleID);
	
	$ROLE.tagCollectorInvoker("cc", optCC, roleTagInit);
	$ROLE.tagCollector("addDataToCtx", 'filterSocialLicence', true);
	$ROLE.tagCollector("addDataToCtx", 'roleID', roleID);
	$ROLE.tagCollector("addDataToCtx", 'socialPageType', socialPageType);
}

/**
 *	Inizializza il template [multiSelectList_BaseTMPL] 
 */
function initMultiSelectListTMPL(refObjId, mshPageId, formName, exportType, multipleValue, showFilter, disable) {
	SCRIPT('jsLib/jquery/multiselection/multiselection.definer.js');
	if (showFilter) {
		CSS('css/jquery_ui/multiselection/jquery.multiselect.filter.css');
		SCRIPT('jsLib/jquery/multiselection/jquery.multiselect.filter.js');
	}
	
	var widget = $("#WC_"+refObjId+" select").multiselectList({
		noneSelectedText: getLabel("noSelection"),
		uncheckAllText: getLabel("multi_deselectAll"),
		checkAllText: getLabel("multi_selectAll"),
		minWidth: 255,
		multiple: (multipleValue=='true') ? true : false,
		header: (multipleValue=='true' || showFilter) ? true : false,
        selectedList: multipleValue ? 3 : 1,
		click: function(event, ui){ sendParams(ui, multipleValue); },
        checkAll: function(event, ui){sendParams(ui, multipleValue); },
    	uncheckAll: function(event, ui){sendParams(ui, multipleValue); },
    	position : {
    		my: "left top",
    		at: "left bottom",
    		collision: "fit none" // Serve ad orientare orizzontlamente il menu di select, in modo che sia sempre visibile
    	},
    	create: function(event, ui){   		
    		$('#dshPageContainer').append($("#WC_"+refObjId+" select").multiselectList("widget"));
    		$("#WC_"+refObjId+" select").multiselectList("position"); // Si calcola la position alla creazione per un problema di posizionamento all aprima apertura
    	}
	});
	if(disable === 'true'){
		$("#WC_"+refObjId+" select").multiselectList('disable');
	} 
	
	if (showFilter) {
		widget.multiselectfilter({label: getLabel("Filter"),
								  placeholder: getLabel("noLicFilter"),
								  width: 165});
	}
	
	$("#WC_"+refObjId+" .ui-multiselect").css({'width': '100%', 'margin-top' : '1px'}).removeClass('ui-corner-all');
	
	function sendParams(ui, isMulti) {
		if (isMulti && isMulti=='true') {
			var list = $("#WC_"+refObjId+" select").multiselect("getChecked").map(function(){
   				return this.value;	
			}).get();
          
          	sendMultipleParamChanged(mshPageId,refObjId,formName, exportType, list);
        }
      	else {
          	sendParamChanged(mshPageId,refObjId,formName, ui.value); 
        }
	}
}

/**
 *	Inizializza i template [multipleToggleBtn_BaseTMPL] e [singleToggleBtn_BaseTMPL] 
 */
function initToggleButtonTMPL(refObjId, mshPageId, formName, exportType, isVertical){ 	
	var alignClass = (isVertical=='true') ? "verticalToggleButton" : "horizontalToggleButton";
	$("#WC_"+refObjId).addClass("MSH_toggleButton "+alignClass).buttonset();
	if(isVertical=='true'){
		var itemWidth = parseInt($("#WC_"+refObjId).css('width').replace("px", "")-8);/*necessario per Chrome altrimenti scrolling inutile*/
		$("#WC_"+refObjId).find("label").addClass("ui-corner-right ui-corner-left")
										.css('width',itemWidth + "px");
	}
}

/**
 *	Inizializza il template [FileDecorator_BaseTMPL] 
 */
function initFileDecoratorTMPL() {
	if($("#FileDecoratorDownloadIF").length<=0) {
	  	var auxIF = document.createElement("iframe");
		$(auxIF).css("display", "none");
		$(auxIF).attr("id", "FileDecoratorDownloadIF");
		
		document.body.appendChild(auxIF);
	}
}

/**
 * Funzionalità per il download dei file allegati presenti nel TagCollector per [FileDecorator_BaseTMPL]
 * author : Pagano Francesco
 * @param nodeFromDom = nodo di riferimento che richiama la function 
 * @param key = key del file sul server
 */
function goDownload(nodeFromDom, key, owner) {

	var completeURL = resourceURL("/cassiopeaWeb/uploadFile/openRepFile.jsp?key=") + key;
	
	if (isDefined(owner)) {
		completeURL += "&csMLO="+owner;
	}
	
	if($("#FileDecoratorDownloadIF").length<=0) {
		
		var auxIF = document.createElement("iframe");
		$(auxIF).css("display", "none");
		$(auxIF).attr("id", "FileDecoratorDownloadIF");
		
		$(nodeFromDom).append(auxIF);
	
		$(auxIF).attr("src", completeURL);
	}	
	else
		$("#FileDecoratorDownloadIF").attr("src", completeURL);
	
}

function addTagFromMenu(tagSelector, tag) {
	hideJQTooltip(tagSelector);

	switch (tag) {
	case ReportDecorator.prefix():
		var textFilteOrig = arguments[2];
		var reportId      = arguments[3];
		var displayName   = arguments[4];
		var owner         = arguments[5];
		var casType       = arguments[6];
		
		$(tagSelector).tagCollector('addTagNode','both', textFilteOrig, {'t':ReportDecorator.prefix(), 'uId' : reportId , 'displayName': displayName, 'owner': owner, 'casType': casType});
		break;
	case TaskDecorator.prefix():
		var textFilteOrig = arguments[2];
		var taskId        = arguments[3];
		var displayName   = arguments[4];
		var owner         = arguments[5];
		var casType       = arguments[6];
		
		$(tagSelector).tagCollector('addTagNode','both', textFilteOrig, {'t':TaskDecorator.prefix(), 'uId' : taskId , 'displayName': displayName, 'owner': owner, 'casType' : casType});
		break;
	case BlogDecorator.prefix():
		var textFilteOrig = arguments[2];
		var taskId        = arguments[3];
		var displayName   = arguments[4];
		var casType       = arguments[5];
		
		$(tagSelector).tagCollector('addTagNode','both', textFilteOrig, {'t':BlogDecorator.prefix(), 'uId' : taskId , 'displayName': displayName, 'casType' : casType});
		break;
	case DocDecorator.prefix():
		var textFilteOrig = arguments[2];
		var docId         = arguments[3];
		var displayName   = arguments[4];
		var owner         = arguments[5];
		var casType       = arguments[6];
		
		$(tagSelector).tagCollector('addTagNode','both', textFilteOrig, {'t':DocDecorator.prefix(), 'uId' : docId , 'displayName': displayName, 'owner': owner, 'casType' : casType});
		break;
	case SigDecorator.prefix():
		var textFilteOrig = arguments[2];
		var docId         = arguments[3];
		var displayName   = arguments[4];
		var owner         = arguments[5];
		var casType       = arguments[6];
		
		$(tagSelector).tagCollector('addTagNode','both', textFilteOrig, {'t':SigDecorator.prefix(), 'uId' : docId , 'displayName': displayName, 'owner': owner, 'casType' : casType});
		break;
	case DashboardDecorator.prefix():
	case DashboardLinkDecorator.prefix():
		var textFilteOrig = arguments[2];
		var dshId         = arguments[3];
		var displayName   = arguments[4];
		var owner         = arguments[5];
		var casType       = arguments[6];
		var link	      = undefined;
		if (arguments.length > 7)
			link	      = arguments[7];
		
		$(tagSelector).tagCollector('addTagNode','both', textFilteOrig, {'t':DashboardDecorator.prefix(), 'uId' : dshId, 'displayName': displayName, 'owner': owner, 'casType' : casType, 'link' : link});
		break;
	case UserDecorator.prefix():
		var textFilteOrig = arguments[2];
		var userId        = arguments[3];
		var userFullName  = arguments[4];
		var casType       = arguments[5];
				
		$(tagSelector).tagCollector('addTagNode','edit', textFilteOrig, {'t':UserDecorator.prefix(), 'uId' : userId, 'displayName': userFullName, 'casType' : casType});
		break;
	case AuthGroupDecorator.prefix():
		var textFilteOrig = arguments[2];
		var groupId       = arguments[3];
		var name          = arguments[4];
		var casType       = arguments[5];
		
		$(tagSelector).tagCollector('addTagNode','edit', textFilteOrig, {'t':AuthGroupDecorator.prefix(), 'uId' : groupId, 'displayName': name, 'casType' : casType});
		break;
	case TextTagDecorator.prefix():
		var textFilteOrig = arguments[2];
		var id            = arguments[3];
		var displayName   = arguments[4];
		var casType       = arguments[5];
		
		$(tagSelector).tagCollector('addTagNode','edit', textFilteOrig, {'t':TextTagDecorator.prefix(), 'uId' : id, 'displayName': displayName, 'casType' : casType});
		break;
	case CategoryDecorator.prefix():
		var textFilteOrig = arguments[2];
		var id            = arguments[3];
		var displayName   = arguments[4];
		var casType       = arguments[5];
		$(tagSelector).tagCollector('addTagNode','edit', textFilteOrig, {'t':CategoryDecorator.prefix(), 'uId' : id, 'displayName': displayName, 'casType' : casType});
		break;
	case SocialGroupDecorator.prefix():
		var textFilteOrig = arguments[2];
		var id            = arguments[3];
		var dispalyName   = arguments[4];
		var casType       = arguments[5];
		
		$(tagSelector).tagCollector('addTagNode','edit', textFilteOrig, {'t':SocialGroupDecorator.prefix(), 'uId' : id, 'displayName': dispalyName, 'casType' : casType});
		break;
	case SocialAreaDecorator.prefix():
		var textFilteOrig = arguments[2];
		var id            = arguments[3];
		var displayName   = arguments[4];
		var casType       = arguments[5];
		
		$(tagSelector).tagCollector('addTagNode','edit', textFilteOrig, {'t':SocialAreaDecorator.prefix(), 'uId' : id, 'displayName': displayName, 'casType' : casType});
		break;
	case SocialInitiativeDecorator.prefix():
		var textFilteOrig = arguments[2];
		var id            = arguments[3];
		var displayName   = arguments[4];
		var casType       = arguments[5];
		
		$(tagSelector).tagCollector('addTagNode','edit', textFilteOrig, {'t':SocialInitiativeDecorator.prefix(), 'uId' : id, 'displayName': displayName, 'casType' : casType});
		break;
	default:
		break;
	}}

function canRenderTargetBox(ctx){
	var endRefObjectKey = getCtxValue('refObjectKey', ctx);
  	endRefObjectKey = endRefObjectKey.substr(endRefObjectKey.length-8);
	var refObjectType = getCtxValue('refObjectType', ctx);
	return ((refObjectType=="1" && endRefObjectKey=="bodyCell") || refObjectType=="119");		
}

function giveMore($this) {	
	var subM = $this.parent().next("div");
	
	if(subM.css("display") == "none"){
		$this.addClass('de_icoArrowUpSmall').removeClass('de_icoArrowDownSmall');
		subM.show("fast",function(){
			$($this.get(0).offsetParent.offsetParent).qtip('reposition');
		});
	} else {
		$this.addClass('de_icoArrowDownSmall').removeClass('de_icoArrowUpSmall');
		subM.hide("fast", function(){
			$($this.get(0).offsetParent.offsetParent).qtip('reposition');
		});
	}
	
}

function showNextTable($this, $iconSpan, classDisplay, classHide) {	
	var subM = $this.next("table");
	if(subM.css("display") == "none"){
		subM.show("fast");
		if ($iconSpan && classDisplay)
			$iconSpan.attr("class", classDisplay);
	} else {
		subM.hide("fast");
		if ($iconSpan && classHide)
			$iconSpan.attr("class", classHide);
	}
	
	
	
}

function showNextObject($this, obj) {	
	var subM = $($this).next(obj);
	if(subM.css("display") == "none"){
		subM.show("fast");
	} else {
		subM.hide("fast");
	}
	
}


/**
 * Init for the decisyon smart wizard plugin
 */
function initDcySmartWizard(context, stepNumber, selectedStep){

  	SCRIPT("jsLib/wizard/wizard.js");
	CSS("css/wizard/wizard.css");
	
	var wizardMinWidth = 780;	//min-width for the smart wizard
	var wizardMinHeight = 250;	//min-height for the smart wizard
	var hActionBar = 42;	//action bar height
	
	var ctx = JSON.parse(context).ctx;	
	var wizardId = getCtxValue('refObjId', ctx); 
    var wFormName = getCtxValue('wizardFormName', ctx);
    var wExecBtn = getCtxValue('wizExecButton', ctx);
    var wTransEffect = getCtxValue('transitionEffect', ctx); 
    var orientation = getCtxValue('pageOrientation', ctx);   	
  	var wContainer = getCtxValue('min-width', ctx); 
  	var hContainer = getCtxValue('min-height', ctx); 
  	
  	var nSteps = stepNumber;
    var isHorizontal = (orientation == 'horizontal') ? true : false;    
    
    var $wizard = $('#wizard_'+wizardId);
    $wizard.hide();
  	if (parseInt(nSteps)>0){
		$wizard.smartWizard({
      		selected: selectedStep
      		, onFinish: callbackWizardFinish
      		, dshWizardId: wizardId
      		, dshWizardParamName: wFormName
      		, dshExecuteObjId: wExecBtn
      		, prefixStepId: 'WIZARD'+wizardId
      		, transitionEffect: wTransEffect
		});
		
		wContainer = (wContainer!="" && wContainer>0)? wContainer : wizardMinWidth;
	  	hContainer = (hContainer!="" && hContainer>0)? hContainer : wizardMinHeight;    
		if (!isHorizontal){
			setDcySmartWizardVertical($wizard, wContainer, hContainer, hActionBar);   
		}else{
			setTimeout(function(){setDcySmartWizardHorizontal($wizard, wContainer, hContainer, hActionBar);},0);
		}
		  $wizard.show();
  	}	
};
/**
 * Sets the the decisyon smart wizard plugin with the horizontal orientation
 * @param $wizard
 * @param wContainer
 * @param hContainer
 * @param hActionBar
 */
function setDcySmartWizardHorizontal($wizard, wContainer, hContainer, hActionBar){
	var hSteps = 64;	// steps list height
	var wContent = wContainer - 12;
	var hContent = hContainer - hSteps - hActionBar;
	$wizard.addClass("swHorizontal")
    	.find('.stepContainer')
    	.css({"height": hContent, "width": wContent})
    	.find("div.content").css({"height":hContent, "width": wContent});
	$wizard.find('ul').css({'width': wContent});
};
/**
 * Sets the the decisyon smart wizard plugin with the vertical orientation
 * @param $wizard
 * @param wContainer
 * @param hContainer
 * @param hActionBar
 */
function setDcySmartWizardVertical($wizard, wContainer, hContainer, hActionBar){
	var wContent = wContainer - 180;
  	var hContent = hContainer - hActionBar - 20;	
    $wizard.addClass("swVertical");
  	
  	$wizard.find('ul.anchor')
  		.css({"width": 160, "height" : hContainer, "float": "left"})
  		.find("li").css("float", "left");
  	$wizard.find('.stepContainer')
      	.css({"width": wContent, "height": hContent})
    	.find("div.content").css({"width": wContent, "height": hContent});
  	$wizard.find('.actionBar').css({"width": wContent});     
};

/**
 * Init the contents swicth view section (template headerSwitchView_BaseTMPL	 )
 * @param mshPageId
 * @param pageParams
 * @param refObjId
 */
function initContentsSwitchView(mshPageId, pageParams, refObjId){
	CSS('jsLib/socialContent/headerSwitchAndSearch.css');
	var crosstabId = getPageParamValue('CROSSTAB_ID', pageParams);
	var selectedView = getPageParamValue('SPECIFIC_VIEW_'+crosstabId, pageParams);
	var viewList = getPageParamValue('VIEW_LIST', pageParams);
	var viewGrid = getPageParamValue('VIEW_GRID', pageParams);	

	if (selectedView == viewList){
		setContentsBtnToSwitchToListView(refObjId);
	}else if (selectedView == viewGrid){
		setContentsBtnToSwitchToGridView(refObjId);
	}	
	setContentsBtnToSwitchView(refObjId);
};
/**
 * Sets the contents swicth view section buttons
 * @param refObjId
 */
function setContentsBtnToSwitchView(refObjId){
	var $viewBtn = $('.de_view_callout > a', $('#OBJ'+refObjId));
	var $listBtn = $viewBtn.eq(0);
	var $gridBtn = $viewBtn.eq(1);
	$listBtn.click(function(){
		setContentsBtnToSwitchToListView(refObjId);
	});
	$gridBtn.click(function(){
		setContentsBtnToSwitchToGridView(refObjId);
	});
};
/**
 * Sets the contents swicth view button for the list view
 * @param refObjId
 */
function setContentsBtnToSwitchToListView(refObjId){
	var $viewBtn = $('.de_view_callout > a', $('#OBJ'+refObjId));
	var $listBtn = $viewBtn.eq(0);
	var $gridBtn = $viewBtn.eq(1);
	$listBtn.removeClass('de_btn_list').addClass('de_btn_list_active');
	$gridBtn.removeClass('de_btn_table_active').addClass('de_btn_table');
};
/**
 * Sets the contents swicth view button for the grid view
 * @param refObjId
 */
function setContentsBtnToSwitchToGridView(refObjId){
	var $viewBtn = $('.de_view_callout > a', $('#OBJ'+refObjId));
	var $listBtn = $viewBtn.eq(0);
	var $gridBtn = $viewBtn.eq(1);
	$listBtn.removeClass('de_btn_list_active').addClass('de_btn_list');
	$gridBtn.removeClass('de_btn_table').addClass('de_btn_table_active');
};
/**
 * Switch the crosstab view(list/grid) and send param changed
 * @param mshPageId
 * @param crosstabId
 * @param viewToSwitch
 */
function switchViewCrosstabAndSendParamChanged(mshPageId, crosstabId, viewToSwitch){
	var paramSpecificViewName = 'SPECIFIC_VIEW_' + crosstabId;
	var paramSpecificViewId = $("[name='"+paramSpecificViewName+"']").attr('id');
	sendParamChanged(mshPageId, paramSpecificViewId, paramSpecificViewName, viewToSwitch);
	
	if( $("#de_refreshable_contents").attr( "refreshFlag") ) {
		$("#de_refreshable_contents").removeAttr( "refreshFlag");
		refreshReport(  $("#OBJ"+crosstabId ).attr( "reportviewid" ) );
	} else {
		reloadTemplate("#OBJ"+crosstabId, viewToSwitch);
	}
};
/**
 * Sets the search objects in the contents swicth view section
 * @param mshPageId
 * @param refObjId
 */
function setContentsSearcher(mshPageId, refObjId, searchPlaceholder){	
	var $searchInput = $('.de_search_input', $('#OBJ'+refObjId));
	var $searchSubmit = $('.de_search_submit', $('#OBJ'+refObjId));
	var $searchCancel = $('.de_search_cancel', $('#OBJ'+refObjId));
	var paramName = 'SEARCH';
	var $hSearch = $("[name='"+paramName+"']");
	if(searchPlaceholder!=null && searchPlaceholder!=""){
		$searchInput.attr('placeholder', searchPlaceholder);
		
	}
	$searchInput.val($hSearch.val());
	var paramId = $hSearch.attr('id');  	
	setContentsSearchInput($searchCancel, $searchInput, $searchSubmit, $hSearch, mshPageId, paramId, paramName);
	setContentsSearchSubmit($searchCancel, $searchInput, $searchSubmit, $hSearch, mshPageId, paramId, paramName);
	setContentsSearchCancel($searchCancel, $searchInput, $searchSubmit, $hSearch, mshPageId, paramId, paramName);
};
/**
 * Sets the search input in the contents swicth view section
 * @param $searchCancel
 * @param $searchInput
 * @param $searchSubmit
 * @param $hSearch
 * @param mshPageId
 * @param paramId
 * @param paramName
 */
function setContentsSearchInput($searchCancel, $searchInput, $searchSubmit, $hSearch, mshPageId, paramId, paramName){	
	$searchInput.on( 'focus', function() { 
    	$searchSubmit.show();
    	$searchCancel.hide();
	});	    
	    
	$searchInput.on( 'keyup', function() { 
    	beLate(function(){
    		if( $searchInput.val()) {
    			$searchSubmit.hide(); 
    			$searchCancel.show();    	    			
    		}else{
    			$searchSubmit.show(); 
    			$searchCancel.hide();  
    		}
    		$hSearch.val($searchInput.val());
			sendParamChanged(mshPageId, paramId, paramName, $hSearch.val());
    	}, 500);
    });
};
/**
 * Sets the search submit button in the contents swicth view section
 * @param $searchCancel
 * @param $searchInput
 * @param $searchSubmit
 * @param $hSearch
 * @param mshPageId
 * @param paramId
 * @param paramName
 */
function setContentsSearchSubmit($searchCancel, $searchInput, $searchSubmit, $hSearch, mshPageId, paramId, paramName){
	$searchSubmit.on( 'click', function() {
		if( $searchInput.val() ) { 
	    	$hSearch.val($searchInput.val());
	        $(this).hide();
	        $searchCancel.show();
	        sendParamChanged(mshPageId, paramId, paramName, $hSearch.val());
		}
	});
};
/**
 * Sets the search cancel button in the contents swicth view section
 * @param $searchCancel
 * @param $searchInput
 * @param $searchSubmit
 * @param $hSearch
 * @param mshPageId
 * @param paramId
 * @param paramName
 */
function setContentsSearchCancel($searchCancel, $searchInput, $searchSubmit, $hSearch, mshPageId, paramId, paramName){
	$searchCancel.on('click', function() { 
		$searchInput.val('');
		$hSearch.val($searchInput.val());
		sendParamChanged(mshPageId, paramId, paramName, $hSearch.val());
        $(this).hide(); 
        $searchSubmit.show();
	});
};
/**
 * Sets the contents title in the contents swicth view section
 * @param contentTitle
 * @param refObjId
 */
function setContentsTitle(contentTitle, refObjId){
	$('.de_content_title', $('#OBJ'+refObjId)).html(LANGUAGES.getOriginalLabel(contentTitle));
};
/**
 * Add the active class on the selected item 
 * @param item
 */
function activeDeItem(item){
	var $parentList = $(item).closest('ul');
	$('li', $parentList).removeClass('de_active');
	$(item).addClass('de_active');
};
/**
 * When select the tooltip selector item
 * @param item
 * @param refObjId
 */
function whenSelectTipSelectorItem(item, refObjId){
	var $itemChild = $('a', $(item));
	var itemText = $itemChild.html();
	$('#selector_'+refObjId).html(itemText);
	activeDeItem(item);
	var $tmpItemList = $('li', $('.MSH_tooltipItems', $('#OBJ'+refObjId)));
	$tmpItemList.removeClass('de_active');
	$tmpItemList.eq($(item).index()).addClass('de_active');	
	$('.qtip').qtip('hide');		
};
/**
 * Init the contents search section (template headerContentSearch_BaseTMPL	 )
 * @param mshPageId
 * @param pageParams
 * @param refObjId
 */
function initContentsSearch(mshPageId, pageParams, refObjId){
	CSS('jsLib/socialContent/headerSwitchAndSearch.css');
	var contentTitle = getPageParamValue('CONTENT_TITLE', pageParams);
	var searchPlaceholder = getPageParamValue('SEARCH_PLACEHOLDER', pageParams);
	setContentsSearcher(mshPageId, refObjId, searchPlaceholder);
	setContentsTitle(contentTitle, refObjId);
};
/**
 * Init the inbox mashboard
 */
function initDcyInboxMashboard(){
	//var $objTextForToolbar = $('#OBJ967362741535930');
	//var $objTextForToolbar = $('#OBJ66362668012104');
	var $objColLayoutForSearch = $('#OBJ49362731117349');
	
	//Remove the jquery class to apply the transparency
	$objColLayoutForSearch.removeClass('dcy_ui-widget-content');
	
	//Set the toolbar labels
	//$('label[for=chk_selectAll]', $objTextForToolbar).html(LANGUAGES.getOriginalLabel('selectAll'));
//	$('#btnMarkAsUnread', $objTextForToolbar).html(LANGUAGES.getOriginalLabel('markAsUnread')).attr('disabled', true).addClass('ui-state-disabled');
//	$('#btnMarkAsRead', $objTextForToolbar).html(LANGUAGES.getOriginalLabel('markAsRead')).attr('disabled', true).addClass('ui-state-disabled');
//	$('#btnDelete', $objTextForToolbar).html(LANGUAGES.getOriginalLabel('Delete')).attr('disabled', true).addClass('ui-state-disabled');
//	$('#btnMarkAsUnread', $objTextForToolbar).attr('disabled', true);
//	$('#btnMarkAsRead', $objTextForToolbar).attr('disabled', true);
//	$('#btnDelete', $objTextForToolbar).attr('disabled', true);
	
	$(window).resize(function () {
	      resizeDcyInBox();
	});
	resizeDcyInBox();
	setupInboxStyleSelector();
	var $tmpItemList = $('li', $('.MSH_tooltipItems', $('#OBJ59362669967420')));
	$tmpItemList.click(function(){
		setupInboxStyleSelector();
	});
};
/**
 * Resize the inbox mashboard
 */
function resizeDcyInBox() {
	var documentHeight = $(window).height();
	var headerHeight = $("#OBJ46362731043762").height();
	var inboxHeight = 0;
	if( $(window).width() <= 1024 ) {
		inboxHeight = documentHeight - headerHeight + 70;
	} else {
		inboxHeight = documentHeight - headerHeight - 20;
	}
    var $objInboxContainer = $("#OBJ177362668581046");
    $objInboxContainer.height(inboxHeight);
    setupInboxStyleSelector();
    $("#OBJ65362668012104_BODY").css({'overflow-y' : 'hidden'});
    $("#OBJ63362668012104_BODY").css({'overflow-y' : 'hidden'});
    $("#OBJ177362668581046").css({'overflow-y' : 'hidden'});
    $(".de_paging_list", "#OBJ76362668012104").css({'padding-bottom' : '8px'});
    
    
};

/**
 * Return if the notification is available (ref. PROCESSING_EVENT_NOTIFICATION_GROUP_ENUM.java)
 * @param dataNotificationGroup
 * @returns {Boolean}
 */
function isInboxNotificationaAvailable(dataNotificationGroup){
	
	switch(dataNotificationGroup) {
		case "SIGNAL":
			return true;
		break;	  
		  
		case "SIGNAL_DISCUSSION":
			return true;
		break;
				  
		case "CONTENT": 
			return true;
		break;
		 
		case "CONTENT_DISCUSSION":
			return true;
		break;
		
		case "DISCUSSION":
			return true;
		
		case "TASK":
			return true;
		
		case "TASK_DISCUSSION":
			return true;
		
		case "ANNOTATION_DISCUSSION":
			return true;
		
		case "JOIN_DISCUSSION":
			return true;
			
		default:
			return false;
	  }
}

function openFollowDialog(obj, refObjId, refObjectType, owner, callback) {
	var ctx = new ctxManager(obj!=null? getCtx(obj) : new Array());
	if (refObjId!=null)
		ctx.set('refObjId', refObjId);
	if (refObjectType!=null)
		ctx.set('refObjectType', refObjectType);
	if (owner!=null)
		ctx.set('owner', owner);
	
	closeAllTips(); //Chiudo tutti i tooltip esistenti per fare spazio al popup in questione
	
	createJQDialogWithDataProvider("jqFollowDialog", "", callback!=null?callback:"", function() {
			JQConfirm("jqRemoveAllStream", LANGUAGES.getOriginalLabel("jq_confirm"), LANGUAGES.getOriginalLabel("StopReceivingUpdates"), function() {
				var followStreamsList = $('#followStreamsList', rootPage.$("#jqFollowDialog"));
				setCtx(followStreamsList, ctx.ctxObject);
				removeAllFollows(followStreamsList);
				handleAjaxCall(followStreamsList, 'REMOVE_FOLLOWS', null, false, null, callback);
				rootPage.closeJQDialog("jqFollowDialog");
			}, "");
			return false;
		}, true, "", "Follow", 600, 400, "", "", true, true, 
		false, "", false, false, LANGUAGES.getOriginalLabel("RemoveAll"), LANGUAGES.getOriginalLabel("Close"), 'socialFollow', ctx.toString());
}

function confirmFollowDialog() {
	var dlgId = 'followDialog';
	var jqDialog = rootPage.$("#"+dlgId);
	var confirmFunction = jqDialog.data("callbackConfirm");
	if (confirmFunction!=null) {
		var openDialogWindow = rootPage.getWindowReferenceFromRootPage(dlgId);
		openDialogWindow.eval(confirmFunction);
	}
	rootPage.closeJQDialog(dlgId);
}

/*********** BOOKMARK **********/

/**
 * Gestione comune degli errori sui bookmark
 * 
 * @param errorDPR
 */
function manageCommonBookmarkErrorDPR(errorDPR, $elementToAllarm) {
	var errorMsg = errorDPR.data.error.errorMsg;
//	var errorCode = errorDPR.data.error.errorCode;
//	var errorDetails = errorDPR.data.error.errorDetails;
	
	setElementInError($elementToAllarm, $elementToAllarm, true, errorMsg);
}

/**
 * Error Code EBOOK001 management
 * 
 * @param errorDPR
 */
function manageErrorDPR_EBOOK001(errorDPR) {
	manageCommonBookmarkErrorDPR(errorDPR, $('#associatedAreasDiv'));
}

function openBookmarkDialog(obj, refObjId, refObjectType, owner) {
	var ctx = new ctxManager(obj!=null? getCtx(obj) : new Array());
	if (refObjId!=null)
		ctx.set('refObjId', refObjId);
	if (refObjectType!=null)
		ctx.set('refObjectType', refObjectType);
	if (owner!=null)
		ctx.set('owner', owner);
	
	closeAllTips(); //Chiudo tutti i tooltip esistenti per fare spazio al popup in questione
	createJQDialogByDPrWithOptions('bookmarkDialog', 'socialBookmark', ctx.toString(), 'Bookmark', 500, 420, true); 
}

function saveNewBookmark(obj, $title, $description, starVal, $tags) {
	if (!validateCreateBookmark($title, $tags, $description))
		return;
	
	setCtxNodeValue(obj, 'refObjName', $title.val());
	setCtxNodeValue(obj, 'refObjKeyDesc', $('#description').val());
	setCtxNodeValue(obj, 'preferred', starVal.val());
	setCtxNodeValue(obj, 'associatedAreas', $tags.tagCollector('getJson'));
	setCtxNodeValue(obj, 'action', 'CREATE');

	var $cancelButton = $(obj).parent().next().find(".de_generic_cancel_button");
	
	var beforeCallBack = function(){
		loadingButton($(obj));
		$cancelButton.attr('disabled','disabled');
	};
	
	var successCallBack = function() {
		unloadingButton($(obj));
		$cancelButton.removeAttr('disabled','disabled');
		closeJQDialog("bookmarkDialog");
//		'rootPage.closeJQDialog("bookmarkDialog");'
	};
	
	var errorCallback = function(jqXHR, textStatus, errorThrown) {
		unloadingButton($(obj));
		$cancelButton.removeAttr('disabled','disabled');
	};
	
	handleAjaxCall(obj, 'SOCIAL_BOOKMARK', null, false, null, successCallBack, errorCallback, beforeCallBack);
}

function deleteBookmarkById(obj, refObjId, bookmarkName, bmkObjId) {

	setCtxNodeValue(obj, 'refObjId', refObjId);
	setCtxNodeValue(obj, 'refObjName', bookmarkName);
	setCtxNodeValue(obj, 'refObjectType', 0);
	setCtxNodeValue(obj, 'refObjKeyDesc', '');
	setCtxNodeValue(obj, 'preferred', 0);
	setCtxNodeValue(obj, 'associatedAreas', '');
	
	var mshId = getValueFromCtx("mshPageId", obj);
	var owner = getValueFromCtx("owner", obj);
	
	setCtxNodeValue(obj, 'action', 'DELETE_ID');

	var ctx = getRasterCtxContainer(getCtx(obj));
	
	JQConfirm("jqConfirmDeleteBookmark", LANGUAGES.getOriginalLabel("DeleteBookmark"), LANGUAGES.getOriginalLabel("ConfirmDeleteBookmark").replace("%BOOKMARK_NAME%", bookmarkName), function() {
		handleAjaxCall(obj, 'SOCIAL_BOOKMARK', null, false, null, function() {
			var ctx = buildNewCtxObject();
			addDataToCtx(ctx, "refObjId", bmkObjId);
			addDataToCtx(ctx, "owner", "SOCIALM");
			addDataToCtx(ctx, "mshPageId", mshId);
			localSwitchToView($(".de_bookmark_list"), "bookmarksEditor_BaseTMPL", ctx);
		});
	});
}

/**
 * Called on like button click
 */
function socialLikeButtonClick(obj) {
	var contentUID = getValueFromCtx('contentUID', obj);

	var item = rootPage.CONTENT_REFERENCE.getValue(contentUID);
	var data = cloneObject(item.mainInfo.data);

	var likeButton = data.socialLikeButton.likeButton;
	var active = likeButton.active;
	if (active)
		likeButton.count--;
	else
		likeButton.count++;
	likeButton.active = !likeButton.active;

	eval(rootPage.$.observable(item.mainInfo.data).setProperty(data));

	handleAjaxCall(obj,'SOCIAL_LIKE', 'new ctxManager().delegateForAjax', false, null, null);
}

/**
 * Called on prefferd button click
 */
function socialPreferredButtonClick(obj) {
	var contentUID = getValueFromCtx('contentUID', obj);

	var item = rootPage.CONTENT_REFERENCE.getValue(contentUID);
	var data = cloneObject(item.mainInfo.data);

	var preferredButton = data.socialPreferredButton.preferred;
	//var count = parseInt(preferred.count);
	preferredButton.count++;
	preferredButton.count %= 3;
	preferredButton.specificCssClassName = preferredButton.specificCssClassName.replace(/[0-2]/, preferredButton.count);;

	eval(rootPage.$.observable(item.mainInfo.data).setProperty(data));

	handleAjaxCall(obj,'SOCIAL_PREFERRED', 'new ctxManager().delegateForAjax', false, null, null);
}

function validateCreateBookmark($title, $tags, $description) {
	if (!$tags.tagCollector('validate'))
		return false;

	// Controllo che sia impostato un titolo
	$title.removeAttr('invalidMessage');
	var title = $title.val();
	if (title == null || trueTrim(title) == "") {
		$title.attr('invalidMessage', getLabel('crtBookmarkTitleError'));
		setElementInError($title, $title,  true);
		return false;
	}

	$tags.removeAttr('invalidMessage');
	if (JSON.parse($tags.tagCollector('getJson', false)).text.length==0) {
		$tags.attr('invalidMessage', getLabel('crtBookmarkTagsError'));
		setElementInError($tags, $tags, true);
		return false;
	}

	return true;
}

/**
 * Streams handler
 */

function showStream(obj, streamId) {
	$("li a", $(obj).closest("div")).removeClass("de_activity_menu_item_selected");
	$(obj).closest("li a").addClass("de_activity_menu_item_selected");
	sendParamChanged(getValueFromCtx("mshPageId", obj), getValueFromCtx("refObjId", obj), 'selectedStreamId', streamId);
}

function addNewStream(obj, streamName, dshId) {
	if ($.trim(streamName)=="") {
		JQAlertError("jqNoStreamName", "Error", LANGUAGES.getOriginalLabel("NoStreamNameError"), 300, 150);
		return false;
	}
	setCtxNodeValue(obj, "streamName", streamName);
	handleAjaxCall(obj, "LW_CREATE_STREAM", null, false, null, function() {
		sendParamChanged(dshId, "409365175436095", 'dummyStreamChange', Math.random());
		closeJQDialog("jqDialogNewStream");
	}, function() {
		$("#inputStreamName", rootPage.$('#jqDialogNewStream')).focus();
	});
	
	return false;
}

function openNewStreamDialog(obj, dshId) {
	createJQDialogWithDataProvider("jqDialogNewStream", null, "", "addNewStream($('#inputStreamName', rootPage.$('#jqDialogNewStream')), $('#inputStreamName', rootPage.$('#jqDialogNewStream')).val(), " + dshId + ");",
			function(){closeJQDialog("jqDialogNewStream");}, "", LANGUAGES.getOriginalLabel("NewStream"), 600, 200, null, null, true, true, 
			false, "", false, false, null, null, "editStreamName");
}

function renameStream(obj, streamName, streamId) {
	setCtxNodeValue(obj, "streamName", streamName);
	setCtxNodeValue(obj, "streamId", streamId);

	handleAjaxCall(obj, "LW_RENAME_STREAM", null, false, null, function() {
		$("#pEdit_" + streamId, $(obj).closest("div.de_modify_stream")).html(streamName);
	});
	
	$(obj).closest("div").fadeOut();
}

function showStreamRenameBox(obj, streamId, streamOldName) {
	var $box = $("#boxRenameStream");
	var $div = $(obj).closest("div");
	$box.fadeIn();
	$box.offset({top: $div.offset().top + $(obj).closest("#jqDialogEditStream").scrollTop()});
	$("#inputStreamId", $box).val(streamId);
	$("#inputStreamName", $box).val(streamOldName);
}

function hideStreamRenameBox(obj) {
	var $box = $("#boxRenameStream");
	$box.fadeOut();
}

function showBookmarkRenameBox(obj, bookmarkId, bookmarkOldName, bookmarkOldDesc, objectID, containerID, objectOwner, objectType, preferred, refObjId) {
	bookmarkOldName = unescape(bookmarkOldName);
	bookmarkOldDesc = unescape(bookmarkOldDesc);
	var $box = $("#boxRenameBookmark");
	var $div = $(obj).closest("div");
	$box.fadeIn();
	$box.offset({top: $div.offset().top + $(obj).closest("#jqDialogEditBookmark").scrollTop()});
	var contentHeight = $("#boxContent_"+bookmarkId).height();
	$("#boxContent_edit").height(contentHeight);
	$("#boxContent_edit textarea").height(contentHeight - 30);
	$("#inputBookmarkName", $box).val(bookmarkOldName);
	$("#inputBookmarkNameDesc", $box).val(bookmarkOldDesc);
	
	$("#inputBookmarkId", $box).attr("objectID", objectID);
	$("#inputBookmarkId", $box).attr("containerID", containerID);
	$("#inputBookmarkId", $box).attr("objectOwner", objectOwner);
	$("#inputBookmarkId", $box).attr("objectType", objectType);
	
	$("#starBookmark_span", $box).attr("class", "alignCenter IconPreferred-"+preferred);
	$("#starBookmark_input", $box).attr("objectID", objectID);
	$("#starBookmark_input", $box).attr("containerID", containerID);
	$("#starBookmark_input", $box).attr("owner", objectOwner);
	$("#starBookmark_input", $box).attr("objectType", objectType);
	$("#starBookmark_input", $box).val(preferred);
	
	$(".de_bookmark_save", $box).addClass('disabled');
	
	function validateBookmarkEdit(){
		if($("#inputBookmarkName", $box).val()!=bookmarkOldName){
			 enableSaveBookmarkButton();
			return;			
		}
		if($("#inputBookmarkNameDesc", $box).val()!=bookmarkOldDesc){
			 enableSaveBookmarkButton();
			return;
		}
		if(parseInt($("#starBookmark_input", $box).val())!=preferred){
			enableSaveBookmarkButton();
			return;
		}
		if(!$(".de_bookmark_save", $box).hasClass('disabled'))
			$(".de_bookmark_save", $box).addClass('disabled').off("click");
	}	

	function enableSaveBookmarkButton(){
		$(".de_bookmark_save", $box).removeClass('disabled')
			.off("click")
			.on("click", function(){renameBookmark(this, refObjId, containerID);return false;});
	}	

	
	$("#inputBookmarkName", $box).off("keyup").on( "keyup", function(){validateBookmarkEdit();});
	$("#inputBookmarkNameDesc", $box).off("keyup").on( "keyup", function(){validateBookmarkEdit();});
	$("#starBookmark", $box).off("click").on( "click", function(){changePreferredValue(this,false); validateBookmarkEdit();});
	
	$("#bookmarkTypeIco").attr("class", "de_icoType_"+objectType);
}


function hideBookmarkRenameBox(obj, bookmarkId) {
	var $box = $("#boxRenameBookmark");
	$box.fadeOut();
}

var bookmarkEditorRefObjId, bookmarkEditorOwner, bookmarkEditorMshPageId;

function renameBookmark(obj, refObjId, mshPageId) {
	var input = $("#inputBookmarkId");
	var starInput = $("#starBookmark_input");
	setCtxNodeValue(obj, 'refObjId', input.attr("objectID"));
	setCtxNodeValue(obj, 'refObjectType', input.attr("objectType"));
	setCtxNodeValue(obj, 'refObjName', $("#inputBookmarkName").val());
	setCtxNodeValue(obj, 'refObjKeyDesc', $("#inputBookmarkNameDesc").val());
	setCtxNodeValue(obj, 'owner', input.attr("objectOwner"));
	setCtxNodeValue(obj, 'containerId', input.attr("containerId"));
	setCtxNodeValue(obj, 'preferred', starInput.val());
	setCtxNodeValue(obj, 'action', 'UPDATE');
	
	bookmarkEditorRefObjId = refObjId;
	bookmarkEditorOwner = 'SOCIALM';
	bookmarkEditorMshPageId = mshPageId;
	
	var successCallBack = function(){
		$(obj).closest("div").fadeOut();
	};
	
	handleAjaxCall(obj, 'SOCIAL_BOOKMARK', "renameBookmarkCtxDelegate", true, null, successCallBack);
	
	
}

function renameBookmarkCtxDelegate(savingCtx, successCtx){
	addDataToCtx(successCtx, "refObjId", bookmarkEditorRefObjId);
	addDataToCtx(successCtx, "owner", bookmarkEditorOwner);
	addDataToCtx(successCtx, "mshPageId", bookmarkEditorMshPageId);
	return  successCtx;	
}

function deleteStream(obj, streamId, toStreamId) {
	setCtxNodeValue(obj, "streamId", streamId);
	setCtxNodeValue(obj, "toStreamId", toStreamId);
	handleAjaxCall(obj, "LW_DELETE_STREAM", null, false, null, function() {
		if ($('div.de_stream_list [id^="pEdit_"]', $(obj).closest("div.de_modify_stream")).size()==1)
			rootPage.closeJQDialog("jqDialogEditStream");
		else
			$("#pEdit_" + streamId, $(obj).closest("div.de_modify_stream")).parent().remove();
	});
}

function confirmDeleteStream(obj, streamId, streamName) {
	JQConfirm("jqConfirmDeleteStream", LANGUAGES.getOriginalLabel("DeleteStream"), LANGUAGES.getOriginalLabel("ConfirmDeleteStream").replace("%STREAM_NAME%", streamName), function() {confirmAssociateStream(obj, streamId, streamName);});
}

function confirmAssociateStream(obj, streamId, streamName) {
	createJQDialog ("jqConfirmAssociateStream", 0, "", "", function(){openMoveFollowToStream(obj, streamId);}, 
			function(){deleteStream(obj, streamId, -1);}, "", LANGUAGES.getOriginalLabel("AssociateFollowStream"), 500, 200, "", "", true, true, 
			false, LANGUAGES.getOriginalLabel("ConfirmAssociateStream").replace("%STREAM_NAME%", streamName), "", false, false, LANGUAGES.getOriginalLabel("Associate"), LANGUAGES.getOriginalLabel("Delete"));
}

function openStreamsEditorDialog(obj) {
	createJQDialogWithDataProvider("jqDialogEditStream", function() {sendParamChanged(getValueFromCtx("mshPageId", obj), '409365175436095', 'dummyStreamChange', Math.random());}, "", "",
			true, "", LANGUAGES.getOriginalLabel("StreamEditor"), 600, 400, null, null, true, true, 
			false, "", false, false, null, LANGUAGES.getOriginalLabel("Close"), "userStreams", null);

}

function openMoveFollowToStream(obj, streamId) {
	var contextData = new ctxManager();
	contextData.set("streamIdToExclude", streamId);
	contextData.set("viewTMPL", "moveFollowToStream_BaseTMPL");

	createJQDialogWithDataProvider("jqDialogAssociateStream", null, "", function() {associateFollowsToStream(obj, streamId);},
			true, "", LANGUAGES.getOriginalLabel("StreamEditor"), 600, 400, null, null, true, true, 
			false, "", false, false, null, null, "userStreams", contextData.toString());
}

function associateFollowsToStream(obj, streamId) {
	var toStreamId = -1;
	var $destinationStream = $("input:radio[name='destinationStream']:checked", $("div.de_combine_stream"));
	if ($destinationStream.size()>0)
		toStreamId = $destinationStream.val();
	
	setCtxNodeValue(obj, "streamId", streamId);
	setCtxNodeValue(obj, "toStreamId", toStreamId);
	
	deleteStream(obj, streamId, toStreamId);
}

//Removes all streams followed
function removeAllFollows(obj) {
	$("input", $(obj)).removeAttr("checked");
}

function changePreferredValue(obj, sendToServer) {
	var span = $("span", $(obj));
	var input = $("input", $(obj));
	var newVal = (parseInt(input.val()))%2+1;
	input.val(newVal);
	span.removeClass();
	span.addClass("IconPreferred-" + newVal);
	span.attr("title", getLabel('BookmarkTooltipPreferred_' + newVal));
	if (sendToServer) {
		setCtxNodeValue(obj, 'refObjId', input.attr("objectId"));
		setCtxNodeValue(obj, 'refObjectType', input.attr("objectType"));
		setCtxNodeValue(obj, 'owner', input.attr("owner"));
		setCtxNodeValue(obj, 'containerId', input.attr("containerId"));
		setCtxNodeValue(obj, 'preferred', newVal);
		setCtxNodeValue(obj, 'action', 'UPDATE');
		handleAjaxCall(obj, 'SOCIAL_BOOKMARK', null, false, null, null);
	}

}


/**
 * Funzione wrapper per la chiamata a sendCheckListParamChanged
 */
function callSendCheckParamChanged( mshPageId, refObjId, subjectIdVal, subjIdVal, checkVal ) {
    
    param = 'A_' + refObjId + '_' + subjectIdVal;
    
//    alert( "mshPageId: " + mshPageId );
//    alert( "param: " + param );
//    alert( "subjectIdVal: " + subjectIdVal );
//    alert( "subjIdVal: " + subjIdVal );
    
  	sendCheckListParamChanged( mshPageId, param, subjectIdVal, subjIdVal, 0, checkVal );
}

function animateSendCheckParam( obj ) {
	$(obj).closest('div.de_tagInbox').hide().remove();
}

/**
 * Accept a join request in the space
 * @param spaceId
 * @param owner
 * @param contentType
 * @param descContentType
 */
function acceptJoinRequestInTheSpace(spaceId, owner, contentType, descContentType, joinUser, contextContainer){
	callSocialSpaceHandler(spaceId, owner, contentType, descContentType, 'ACCEPT_JOIN_REQUEST_SPACE', 'DO_NOTHING', null, joinUser, contextContainer);
};
/**
 * Join in the space
 * @param spaceId
 * @param owner
 * @param contentType
 * @param descContentType
 */
function joinInTheSpace(obj, spaceId, owner, contentType, descContentType){
	activateLoadingButton(obj);
	callSocialSpaceHandler(spaceId, owner, contentType, descContentType, 'JOIN_SPACE', 'FORWARD_SPACE', obj);
};


/**
 * Activate loading button
 * @param obj
 */
function activateLoadingButton(obj) {
	if (obj) {
		loadingButton($(obj));
		$(obj).addClass("disabled");
		$(obj).css("cursor", "default");
	}
};

/**
 * Deactivate loading button
 * @param obj
 */
function deactivateLoadingButton(obj) {
	if (obj) {
		unloadingButton($(obj));
		$(obj).removeClass("disabled");
		$(obj).css("cursor", "pointer");
	}
};

/**
 * Disjoin in the space
 * @param spaceId
 * @param owner
 * @param contentType
 * @param descContentType
 */
function disjoinInTheSpace(obj, spaceId, owner, contentType, descContentType){
	callSocialSpaceHandler(spaceId, owner, contentType, descContentType, 'DISJOIN_SPACE', 'SHOW_LIST', obj);
};
/**
 * Open the dialog to invite users
 * @param spaceId
 * @param owner
 * @param contentType
 * @param descContentType
 */
function openDialogToInviteUsers(spaceId, owner, contentType, descContentType){
	var owner = 'MASTERM';
	var mshInviteUsersId = "72363594512400";
	var params = '&revent=LW_DSH_LINK&AREA_ID='+spaceId;
	var url = ENV_VARS.getValue("contextPath")+"/cassiopeaWeb/dsh/dshPage.jsp.cas?dshID=" + mshInviteUsersId + "&csMLO=" + owner + params;
	openMashboardIntoModalDialogWithCustomButtons('mshInviteUsers', url, LANGUAGES.getOriginalLabel('inviteUsersToJoin'), 800, 700, 'sendInvite', 'cancel', 'de_btn_invite', 'de_btn_cancel');
};

function openCloseSocialBar(obj, instanceReference) {
	var $socialBar = $("#socialBar"+instanceReference, $(obj).parent());
	if ($(obj).hasClass("de_close")) {
		$socialBar.stop().switchClass("socialBarOpened", "socialBarClosed", "fast");
		$(obj).removeClass("de_close").addClass("de_open");
	} else {
		$socialBar.stop().switchClass("socialBarClosed", "socialBarOpened", "fast");
		$(obj).removeClass("de_open").addClass("de_close");
	}
}

function manageCtxForUsersOn(ctx) {
	var ctx2 = cloneObject(ctx);
	addDataToCtx(ctx2, 'registerContent', true);
	addDataToCtx(ctx2, 'viewTMPL', "usersOnBar_BaseTMPL");
	
	return ctx2;
}

/**
 * Open the dialog to remove the resource image for the context object
 * @param contextId
 * @param imgUploadType
 * @param callbackOnClose
 */
function deleteResourceImage(contextId, imgUploadType, owner, callbackOnClose) {
	JQConfirm("deleteResourceImage", LANGUAGES.getOriginalLabel("removeImage"), LANGUAGES.getOriginalLabel("SubjectPhotoDelConfirm"), "removeImageResource('"+contextId+"', '"+imgUploadType+"','"+owner+"','"+ callbackOnClose+"')");
};
/**
 * Init the activity stream mashboard
 */
function initDcyActivityStreamMashboard(){
	
	$(window).resize(function () {
	      resizeDcyActivityStream();
	});
	resizeDcyActivityStream();
};
/**
 * Resize the activity stream mashboard
 */
function resizeDcyActivityStream() {	
	var documentWidth = $(window).width();
	var $template = $("#OBJ197365168960054");
	var $activityStream = $("#OBJ871361178137827");	
	var newWidth = $template.width() + 10;
	var activityStreamWidth  = documentWidth - newWidth;
	$activityStream.width(activityStreamWidth);
    $("#OBJ945362213821857_BODY").css({'overflow' : 'hidden'});//necessario perché IE visualizza le barre di scrolling per 1 px
};
/**
 * Set the position for the inbox selector
 */
function setupInboxStyleSelector(){
	var $styleSelector = $("#OBJ59362669967420");
	$styleSelector.css({'position': 'absolute', 'top': '70px', 'right': '40px', 'left' : 'auto'}).show();
};
/**
 * Reload the space from space organizer 
 */
function reloadSpaceFromOrganizer(){
	var spaceIframe = $('.spaceOrganizer').find('iframe').get(0);
	spaceIframe.src = spaceIframe.src;
};

/**
* Require membership in the space
* @param spaceId
* @param owner
* @param contentType
* @param descContentType
*/
function requireMembership(obj, spaceId, owner, contentType, descContentType){
	activateLoadingButton(obj);
	callSocialSpaceHandler(spaceId, owner, contentType, descContentType, 'REQUIRE_MEMBERSHIP', 'FORWARD_SPACE', obj);
};
/**
 * Call social space handler
 */
/**
 * @param spaceId
 * @param owner
 * @param contentType
 * @param descContentType
 * @param revent
 * @param actionOnSucces can be SHOW_LIST, FORWARD_SPACE, DO_NOTHING. Default DO_NOTHING.
 * @param obj
 */
function callSocialSpaceHandler(spaceId, owner, contentType, descContentType, revent, actionOnSucces, obj, joinUser, contextContainer, event){
	var ctxNew = buildNewCtxObject(); 
 	addDataToCtx(ctxNew, 'refObjId', spaceId); 
 	addDataToCtx(ctxNew, 'refObjectType', contentType);
 	if (isDefined(joinUser)) {
 		addDataToCtx(ctxNew, 'joinUser', joinUser);
 	}
 	var discCtxIn = null;
 	if (isDefined(contextContainer)) {
 		discCtxIn = contextContainer.auxCtx0;
 	}
 	var rasterCtx = getRasterCtxContainer(ctxNew, discCtxIn);
	$.ajax({
		data: {revent:revent, a0:rasterCtx},
		success: function(response, textStatus, xhr) {
			if (actionOnSucces) {
				switch(actionOnSucces) {
				case 'SHOW_LIST': rootPage.showSpacesListSection(obj, event); break;
				case 'FORWARD_SPACE': manageContentForwardSpace(owner, spaceId, contentType, descContentType); break;
				case 'DO_NOTHING':	// aggiungere logica refresh smart discussion.  
				default:
				}
			}
		},
		error: function (xhr, ajaxOptions, thrownError) {
			deactivateLoadingButton(obj);
		}
	});
};

function setDcyColorPicker($selector, imgUrl, buttonColorizeCssClass, isButtonColorizeEnable, altTextButtonColorize, okCallBack, openCallBackCustom, closeCallBack){
	
	var openCallBack = function(event, color){
		$('.ui-colorpicker-swatches').css('height','132px');
		$('.ui-colorpicker-preview').css({height:'100px', width:'57px', border:'1px solid #ddd',position:'absolute',right:'0',top:'25%'});
		$('.ui-colorpicker-preview-initial, .ui-colorpicker-preview-current').css({height:'100px', width:'50%'});
		$('.ui-colorpicker-hex-input').addClass('colorPickerInput');
		
		if(isDefined(openCallBackCustom) && typeof openCallBackCustom === 'function'){
			openCallBackCustom(event, color);
		}
	};
	
	$selector.colorpicker({
		parts:[	'map', 'swatches', 'hex', 'preview','footer'],
		showOn:         'both',
		buttonImage : imgUrl,
		setColorOnImage : false,
		buttonColorize: false,
		buttonColorizeCssClass : buttonColorizeCssClass ? buttonColorizeCssClass	: 'colorPickerDcyButton',
		isButtonColorizeEnable : isDefined(isButtonColorizeEnable) ? isButtonColorizeEnable 	: true,
		altTextButtonColorize  : altTextButtonColorize 	? altTextButtonColorize 	: null,
		layout: {
			map		:	[2, 1, 1, 1],								
			swatches:	[0, 1, 0, 0],
			hex		:	[3, 1, 1, 1]								
		},
		swatchesWidth:	160,
		showSwatchesName: false,
		part:	{
			map:		{ size: 128 }
		},
		open: function(event, color) {
			if(isDefined(openCallBack) && typeof openCallBack === 'function'){
				openCallBack(event, color);
			}
		},
		ok: function(event, color){
			if(isDefined(okCallBack) && typeof okCallBack === 'function'){
				okCallBack(event, color);
			}
		},
		close: function(event, color) {
			if(isDefined(closeCallBack) && typeof closeCallBack === 'function'){
				closeCallBack(event, color);
			}
		}
	});
}
/**
 *	Inizializza la la dialog per impostare la formattazione delle metriche sul report [metricFormatSettings.jsp]
 *
 * @param metricDisplayName
 * @param centralConditionalFormat
 * @param positiveConditionalFormat
 * @param negativeConditionalFormat
 */
function initMetricFormatSettings(metricDisplayName, centralConditionalFormat,positiveConditionalFormat,negativeConditionalFormat){
	var jqDialog = rootPage.$('#jQMetricFormat');
	jqDialog.dialog("option", "title", LANGUAGES.getLabelHTMLEncode("metricFM1") +" \""+ metricDisplayName+"\" ");

	var fgColor = '../../../img/fgcolor.png';
	var bgColor = '../../../img/bgcol.png';
	var buttonClass = 'colorPickerDcyButton';
	var fgAlt = LANGUAGES.getLabelHTMLEncode("metricFS4");
	var bgAlt = LANGUAGES.getLabelHTMLEncode("metricFS30");
	
	var okCallBack = function(event, color){
		$(event.target.parentNode).find('.setColorDiv').attr("style","background-color:#"+color.formatted+";");
	};
	
	var openCallBackCustom = function(event, color){
		var background_color = $(event.target.parentNode).find('.setColorDiv').css("background-color");
		$(event.target).colorpicker('initColor',background_color);
	};
	
	setDcyColorPicker($('#PositiveForeGroundSelInput'), fgColor, buttonClass, true, fgAlt, okCallBack, openCallBackCustom);
	setDcyColorPicker($('#PositiveBackGroundSelDivInput'), bgColor, buttonClass, true, bgAlt, okCallBack, openCallBackCustom);
	
	setDcyColorPicker($('#NegativeForeGroundSelInput'), fgColor, buttonClass, true, fgAlt, okCallBack, openCallBackCustom);
	setDcyColorPicker($('#NegativeBackGroundSelDivInput'), bgColor, buttonClass, true, bgAlt, okCallBack, openCallBackCustom);
	
	setDcyColorPicker($('#CentralForeGroundSelInput'), fgColor, buttonClass, true, fgAlt, okCallBack, openCallBackCustom);
	setDcyColorPicker($('#CentralBackGroundSelDivInput'), bgColor, buttonClass, true, bgAlt, okCallBack, openCallBackCustom);
	
	$( ".boldItalUnderButtonSet > check" ).button();
    $( ".boldItalUnderButtonSet" ).buttonset();
    
    //set dei check per la formattazione condizionale
	$("#Central_ConditionalFormat").attr("checked",centralConditionalFormat);
	$("#Positive_ConditionalFormat").attr("checked",positiveConditionalFormat);
	$("#Negative_ConditionalFormat").attr("checked",negativeConditionalFormat);
	
	//attiva i pannelli delle metriche secondo la formattazione condizionale;
	toggleConditionalFormat("Central");
	toggleConditionalFormat("Positive");
	toggleConditionalFormat("Negative");
	
	//tolgo il bordo al pannello renderizzato per ultimo
	$(".metricPanel:last").css('border-bottom','0');
};

/*
 * Setta la visibilità del pannello metrica relativo al check della metrica passato come prefisso [usata in metricFormatSettings.jsp]
 * 
 * @param prefixType [Central, Positive, Negative]
 * */
function toggleConditionalFormat(prefixType){
	$foregroundColorDiv = $("#" + prefixType + "ForeGroundSelDiv"); 
	$backGroundColorDIv = $("#" + prefixType + "BackGroundSelDiv");
	
	$selector = $("#" + prefixType + "Container");
	
	if($("#"+prefixType+"_ConditionalFormat").is(":checked")){
		$selector.removeClass("disabled");
		$selector.find(':input').prop('disabled', false);
		$selector.find('button').button('enable');
		$selector.find('.buttonBlock label.ui-button').removeClass("disabled");
	}
	else{
		$selector.addClass("disabled");
		$selector.find(':input').prop('disabled', true);
		$selector.find('button').button('disable');
		$selector.find('.buttonBlock label.ui-button').addClass("disabled");
	}
}	

/*
 * Inizzializza il breadcrumb 
 * 
 * @param  breadCrumbMainContainerId
 * */ 
function initBreadCrumb(breadCrumbMainContainerId){
	
	//cambio logica si deve comprimere solo quando la lunghezza degli elementi contenuti è prossima alla lunghezza del contenitore lasciando un margine di spazio [securityMargin (~100px)}
	var securityMargin = 100;
	var bradCrumbContainerWidth = $(breadCrumbMainContainerId+" div#breadCrumbSetWidthContainer").width();
    var totElementsWIdth = 0;
	var widths = new Array();
	var widthsLenght = 0;

	//setting variabili pubbliche della libreria
	 $.fn.jBreadCrumb.defaults.beginingElementsToLeaveOpen = 0;
	 $.fn.jBreadCrumb.defaults.timeExpansionAnimation = 0;
	 $.fn.jBreadCrumb.defaults.timeCompressionAnimation = 0;
	 $.fn.jBreadCrumb.defaults.timeInitialCollapse = 0;
	 $.fn.jBreadCrumb.defaults.easing = '';
	 $.fn.jBreadCrumb.defaults.previewWidth = 10;
	
	 $(breadCrumbMainContainerId).find('li').each(function(ii) {
		 widths[ii] = $(this).outerWidth();
		 totElementsWIdth += widths[ii];
	 });
	 widthsLenght = widths.length;
	 
	 if ((totElementsWIdth + $.fn.jBreadCrumb.defaults.minFinalElementLength) > bradCrumbContainerWidth){		 
		 var calculatedWidth = totElementsWIdth;
		 for( var iz = 1; iz < widthsLenght; iz++ ){
			 calculatedWidth -=widths[iz];
			 calculatedWidth += 15; //width = 10px della previewWidth  + 5px della gif 
			 
			 if (bradCrumbContainerWidth > calculatedWidth + securityMargin ){
				 $.fn.jBreadCrumb.defaults.endElementsToLeaveOpen = (widthsLenght - iz - 2 > -1 )? (widthsLenght - iz - 2): 0;
				 $.fn.jBreadCrumb.defaults.minimumCompressionElements = ((widthsLenght--) > 3) ? (widthsLenght--) : 3;
				 break;
			 }
		 }		
	 }
	 else{
		 $.fn.jBreadCrumb.defaults.endElementsToLeaveOpen = widthsLenght;
		 $.fn.jBreadCrumb.defaults.minimumCompressionElements = widthsLenght;
	 }  				 

	 //crea il breadcrumb e fa comparire i tre puntini sui nodi compressi al posto del testo e viceversa
	 $(breadCrumbMainContainerId).jBreadCrumb()
								 .find('li>span>a').each(function() {									 	 		   
									 			   $(this).text("...")
									 			   		  .closest('li').on({
																mouseenter: function(e){
																	 e.preventDefault();
																	 stopPropagation();
																	 $(this).find('a').html( $(this).find('a').attr("menulink"));

																},
																mouseleave: function(e){
																	 e.preventDefault();
																	 stopPropagation();
																	 $(this).find('a').html("...");
																}
									 					  });
							     });			 
		 	
}

/*
 * Controlla ciclicamente se è necessario effettuare il ridimensionamento del breadcrumb (compressione espansione degli elementi) 
 * 	al resize della window.   
 * 
 * @param  breadCrumbMainContainerId
 * */ 
function checkBreadCrumbResize(breadCrumbMainContainerId){	
	
	// la var breadCrumbHtmlDiv conserva l'html del breadcrumb prima di 
	//	inizializzare il plugin (necessario per le future eventuali ri-inizzializzazioni).
	var breadCrumbHtmlDiv = $('div#'+breadCrumbMainContainerId).html(); 
	initBreadCrumb('#'+breadCrumbMainContainerId);
	var resizeTimer; 
	var containerWidth = $('div#'+breadCrumbMainContainerId).width(); 
	//controlla se la width del contenitore del breadCrumb è cambiata e nel caso affermativo lo ri-inizializza.
	function resizeBreadCrumbFunction(){ 
			if( !($('div#'+breadCrumbMainContainerId).width() ==  containerWidth)){ 
					containerWidth = $('div#'+breadCrumbMainContainerId).width(); 
					$('div#'+breadCrumbMainContainerId).html(breadCrumbHtmlDiv);  
					initBreadCrumb('#'+breadCrumbMainContainerId);
			} 
	}; 
	//attacca un handler all'evento resize della window.
	//ogni volta che si scatena l'evento pulisco il timeout e ri-inizializzo il timer 
	//	in questo modo esegue la funzione solo sull'ultimo ridimensionamento della window.    
	$(window).off('resize.breadCrumbResize').on('resize.breadCrumbResize',function() { 
																			clearTimeout(resizeTimer); 
																			resizeTimer = setTimeout(resizeBreadCrumbFunction, 250);
																		  });		
}


/**
 * INITIATIVE
 * Inizializzazione template relativo al campo Due Date Reason presente negli spazi sociali di tipo iniziativa
 * @param spaceId
 * @param pageParams
 * @param refObjId
 * @param editDescription
 */
function initSpaceDueDateReasonInEdit(spaceId, pageParams, refObjId, editDescription){
	var dueDateReason = null;
	if (pageParams && pageParams.SPACE_DUE_DATE_REASON && pageParams.SPACE_DUE_DATE_REASON.length > 0){
		dueDateReason = pageParams.SPACE_DUE_DATE_REASON[0];			
	}
	var $spaceDueDateReason = $('#spaceDueDateReason');
	
	var optDescr = { 
		editable			  : editDescription,
		editViewMode		  : editDescription ? 'edit' : 'view',/* per disabilitare anche i link: mettere "text" al posto di "view" */
		view				  : 'edit'
	};		
	$spaceDueDateReason.tagCollectorInvoker("descrPlugin", optDescr, dueDateReason);
}

/**
 * INITIATIVE
 * Inizializzazione dell'informazione Due Date Reason presente nell'organizer degli spazi sociali di tipo iniziativa
 * @param dueDateReason
 */
function initSpaceDueDateReasonInView(dueDateReason){	
	$(document).ready(function(){
		var $spaceDueDateReason = $('#spaceDueDateReason');
		if ($spaceDueDateReason && $spaceDueDateReason.length > 0){		
			$spaceDueDateReason.get(0).innerHTML = tagCollectorHTMLrenderer(dueDateReason, 'edit', 'view', 'view', false);
		}	
	});
}

/**
 * INITIATIVE
 * Refresh the space due date in timestamp classname, with a pretty date value.
 */
function initSpaceDueDateAsPretty(){
	refreshPrettyDateIntoPage(document.getElementById('spaceDueDateMsg'));
}

/**
 * INITIATIVE
 * Script JS richiamato dal mashboard InitiativeAdvancedSettings
 * (Mashboard step 2 del wizard delle iniziative)
 * abilita/disabilita i campi: due date time, timezone e reason
 * @param disabled
 */
function setSpaceDueDateFieldsAsDisabled(disabled){
	setTimeout(function(){
		var inputDueDateTime = $('#spaceDueDateTime'),
			txaDueDateReason = $('#spaceDueDateReason'),
			selectTimezone = $('select#timeZoneSelect', $('#OBJ140445436760724_BODY')),
			classDisabled = 'disabled';
	
		inputDueDateTime.attr('disabled', disabled);
		txaDueDateReason.attr('disabled', disabled);
		selectTimezone.attr('disabled', disabled);
		if (disabled){
			inputDueDateTime.addClass(classDisabled);
			txaDueDateReason.addClass(classDisabled);	
			selectTimezone.addClass(classDisabled);	
		}else{
			inputDueDateTime.removeClass(classDisabled);	
			txaDueDateReason.removeClass(classDisabled);	
			selectTimezone.removeClass(classDisabled);
		}
		initSpaceDueDateReasonAsTagCollector(!disabled);	
	}, 100);
}


/**
 * INITIATIVE
 * Script JS richiamato dal mashboard InitiativeAdvancedSettings
 * (Mashboard step 2 del wizard delle iniziative)
 * Se il check Enable due date settings è attivo,
 * - abilita i campi: due date time, timezone e reason;
 * - inizializza il tag collector per il campo reason,
 * - imposta il campo due date time come obbligatorio * 
 * @param paramSpaceEnableDueDate
 */
function manageSpaceDueDateSettings(paramSpaceEnableDueDate){
	var containerDueDate = $('#OBJ228445410644638'),/*id oggetto rowcontainer due date settings*/
		themeRowContainer = 'dcy-theme-1',
		paramDueDate = 'SPACE_DUE_DATE',
		paramDueDateTime = 'SPACE_DUE_DATE_TIME',
		paramDueDateTimezone = 'SPACE_DUE_DATE_TIMEZONE',
		classDisabled = 'disabled';
	
	if (paramSpaceEnableDueDate === '1'){
		setSpaceDueDateFieldsAsDisabled(false);
		containerDueDate.addClass(themeRowContainer).removeClass(classDisabled);
		extMarkParamAsMandatory(paramDueDate);
		extMarkParamAsMandatory(paramDueDateTime);
		extMarkParamAsMandatory(paramDueDateTimezone);
	}else{
		var inputDueDateTime = $('#spaceDueDateTime');
		inputDueDateTime.removeClass('invalidWizard').removeClass('invalid');
		hideJQTooltip(inputDueDateTime);
		var btnFinish = $('.buttonFinish', $('#wizard_78363451682779', $(parent.document.body)));
		btnFinish.removeClass('ui-state-disabled').attr('disabled', false);
		setSpaceDueDateFieldsAsDisabled(true);
		containerDueDate.removeClass(themeRowContainer).addClass(classDisabled);		
		extUnmarkParamAsMandatory(paramDueDate);
		extUnmarkParamAsMandatory(paramDueDateTime);
		extUnmarkParamAsMandatory(paramDueDateTimezone);
	}

}
/**
 * INITIATIVE
 * Script JS richiamato dal mashboard InitiativeAdvancedSettings
 * (Mashboard step 2 del wizard delle iniziative)
 * Inizializza il tag collector del campo reason
 * @param editable
 */
function initSpaceDueDateReasonAsTagCollector(editable){
	var $spaceDueDateReason = $('#spaceDueDateReason'),
		ctx = getCtx(getCtxNode($spaceDueDateReason)),
		pageParams = (ctx && ctx.length > 0) ? getCtxValue('pageParams', ctx) : null,
		spaceId = document.dshIDReference,	/* id mashboard*/
		refObjId = '234445410644638';		/*id oggetto template reason*/
	if (ctx && ctx.length > 0){
		$spaceDueDateReason.tagCollector('destroy');
		initSpaceDueDateReasonInEdit(spaceId, JSON.parse(pageParams), refObjId, editable);	
	}
}
/**
 * INITIATIVE
 * Script JS richiamato dal mashboard InitiativeAdvancedSettings
 * (Mashboard step 2 del wizard delle iniziative)
 * Inizializza il due date time picker
 * @param spaceId
 * @param pageParams
 * @param refObjId
 */
function initSpaceDueDateTime(spaceId, pageParams, refObjId){
	var dueDate = null,
		dueDateTime = null,
		$spaceDueDateTime = $('#spaceDueDateTime');
	
	if (pageParams){
		if (pageParams.SPACE_DUE_DATE && pageParams.SPACE_DUE_DATE.length > 0){
			dueDate = pageParams.SPACE_DUE_DATE[0];
		}
		if (pageParams.SPACE_DUE_DATE_TIME && pageParams.SPACE_DUE_DATE_TIME.length > 0){
			dueDateTime = pageParams.SPACE_DUE_DATE_TIME[0];
		}
	}	
	
	$spaceDueDateTime.dcyDatetimepicker('dd/mm/yy', 'HH:mm', 'selectSpaceDueDateCallback();', 'errorSpaceDueDateCallback();', 'successSpaceDueDateCallback();');
	
	var dNow = new Date();
	if (dueDate === '' || dueDate === null){		
		dueDate = addZeroAndGetTwoDigits(dNow.getDate()) + '/' + addZeroAndGetTwoDigits((dNow.getMonth()+1)) + '/' + dNow.getFullYear();		
		dueDateTime = addZeroAndGetTwoDigits(dNow.getHours()) + ':' + addZeroAndGetTwoDigits(dNow.getMinutes());
	}else{
		dueDate = dueDate.substr(6,2) + '/'+dueDate.substr(4,2) + '/'+ dueDate.substr(0, 4);
	}
	$spaceDueDateTime.val(dueDate + ' ' +dueDateTime);
}

/**
 * INITIATIVE
 * Callback definita sul campo due date time quando si seleziona una data dal calendario
 */
function selectSpaceDueDateCallback(){
	selected = true;
	$(this).datetimepicker("hide");
	var $spaceDueDateTime = $('#spaceDueDateTime');
	
	if ($.trim($spaceDueDateTime.val())===''){
		var dNow = new Date(),
		dueDate = addZeroAndGetTwoDigits(dNow.getDate()) + '/' + addZeroAndGetTwoDigits((dNow.getMonth()+1)) + '/' + dNow.getFullYear(),
		dueDateTime = addZeroAndGetTwoDigits(dNow.getHours()) + ':' + addZeroAndGetTwoDigits(dNow.getMinutes());				
		$spaceDueDateTime.val(dueDate + ' ' +dueDateTime);
	}
	
	var spaceDueDateTimeVal = $.trim($spaceDueDateTime.val()),
		spaceDueDateYear = spaceDueDateTimeVal.substr(6, 4),
		spaceDueDateMonth = spaceDueDateTimeVal.substr(3, 2),
		spaceDueDateDay = spaceDueDateTimeVal.substr(0, 2),
		spaceDueDateTime = spaceDueDateTimeVal.substr(spaceDueDateTimeVal.length-5);    			
	
	sendParamChangedFromExt(document.dshIDReference , 'SPACE_DUE_DATE', spaceDueDateYear+''+spaceDueDateMonth+''+spaceDueDateDay);
	sendParamChangedFromExt(document.dshIDReference , 'SPACE_DUE_DATE_TIME', spaceDueDateTime);
	
};

/**
 * INITIATIVE
 * Callback richiamata in caso di errata digitazione della data
 * Disabilita il tasto Termina del wizard per bloccare il salvataggio dell'iniziativa
 */
function errorSpaceDueDateCallback(){
	var btnFinish = $('.buttonFinish', $('#wizard_78363451682779', $(parent.document.body)));
	btnFinish.addClass('ui-state-disabled').attr('disabled', 'disabled');
}
function successSpaceDueDateCallback(){
	var $spaceDueDateTime = $('#spaceDueDateTime'),
	spaceDueDateTimeVal = $.trim($spaceDueDateTime.val());

	if (spaceDueDateTimeVal==='' && $('input[name="ENABLE_SPACE_DUE_DATE"]').attr('checked') ){
		 throw new Error(LANGUAGES.getOriginalLabel('requiredField'));
	}else{
		selectSpaceDueDateCallback();
		var btnFinish = $('.buttonFinish', $('#wizard_78363451682779', $(parent.document.body)));
		btnFinish.removeClass('ui-state-disabled').attr('disabled', false);
	}
		
};

/**
 * INITIATIVE
 * Inizializza il campo timezone
 * @param spaceId
 * @param pageParams
 * @param refObjId
 */
function initSpaceDueDateTimezone(spaceId, pageParams, refObjId){
	var $timeZoneSelect =  $("#timeZoneSelect");
	if (pageParams){
		if (pageParams.SPACE_DUE_DATE_TIMEZONE && pageParams.SPACE_DUE_DATE_TIMEZONE.length > 0){
			spaceDueDateTimezone = pageParams.SPACE_DUE_DATE_TIMEZONE[0];
			$('option[id="'+spaceDueDateTimezone+'"]', $timeZoneSelect).attr('selected', 'selected');
			$('#timezoneSelected').text(spaceDueDateTimezone);
		}
	}
	
	$timeZoneSelect.change(function() {
		 var mshPageId = document.dshIDReference,
		 spaceDueDateTimezone = $('#timeZoneSelect option:selected').attr('id');
		 $('#timezoneSelected').text(spaceDueDateTimezone);
		 sendParamChangedFromExt(mshPageId, 'SPACE_DUE_DATE_TIMEZONE', spaceDueDateTimezone);
		 setSpaceTimezoneSelectedDstDetails();
	 });
	 setSpaceTimezoneSelectedDstDetails();
	 stopLoadingPage();
}

/**
 * INITIATIVE
 * Inizializza il testo di dettaglio della timezone selezionata
 */
function setSpaceTimezoneSelectedDstDetails() {
	 var dstDetail = $('#timeZoneSelect option:selected').attr('dstDetail');
	 $('#dstDetail').html(dstDetail);
}

/**
 * Get two digits for a number < 10
 * @param i
 * @returns
 */
function addZeroAndGetTwoDigits(i) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}

/**
 *	Inizializza il template [tabMenu_BaseTMPL] 
 */
function initTabMenuTMPL(refObjId, orientation, minWidth, minHeight, disable) {
	var refObject = $("#WC_"+refObjId);
 
  	refObject.tabs();
  	
  	var index = refObject.find("li").index(refObject.find("#tabSelected"));
  	if (index!=-1) { 
  		refObject.tabs( "option", "active", index);
  	}
  	
  	  
  	if (orientation=="TOP") {
   		var w = 1;
		$("#WC_"+refObjId+" li").each(function( index ) {              
       		w +=$(this).outerWidth(true);
		});
		if(minWidth.indexOf("%")!=-1)
			minWidth+="px";
		
		$("#WC_"+refObjId).css('width', minWidth);
		$("#WC_"+refObjId+" ul").css('width', w);

  	}
  	else if (orientation=="BOTTOM") {
  		$("#WC_"+refObjId).css('width', minWidth);
  		refObject.find(".ui-tabs-nav, .ui-tabs-nav > *").removeClass("ui-corner-all ui-corner-top").addClass("ui-corner-bottom");
    }
	else if (orientation== "LEFT") {
		
		refObject.css('width', minWidth);
		refObject.css('height', minHeight);
		
		refObject.addClass('ui-tabs-vertical ui-helper-clearfix');
		refObject.find("li").removeClass('ui-corner-top').addClass('ui-corner-left');
		if (refObject.find('.scrollbar ul').width() < refObject.find('.scrollbar').width()) {
			refObject.find(".ui-tabs-vertical .ui-tabs-nav").css('display','inline');
		}
	}
  	
  	if(disable === 'true'){
		refObject.tabs({
  			disabled: true 
  		});
	} 
  	
}


/**
 *	Inizializza il template [multiselectTable_BaseTMPL] 
 */
function initMultiSelectTableTMPL(refObjId, mshPageId, formName, exportType, isTransparent, disable) {
	SCRIPT('jsLib/jquery/multiselection/multiselection.definer.js');
	
	$WCS_refObj = $("#WCS_"+refObjId);
	
	var option = {
			availableListPosition: 'left',
			selectionMode: ENV_VARS.isOnTouchDevice()?'click':'click,d&d'
	};
	
	
	$WCS_refObj	.multiselectTable_20(option)
				.on('multiselectComplete',function(event, ui){
					
					
					if(disable === 'true'){		
						ui._elementWrapper.find('*').off().removeData();
						ui._elementWrapper.addClass('dcyOpacity50 de_cursorDefault');
					}
					else{
						var sendParams = function(ui) {
							var list = $WCS_refObj.val();
							if (list==null){list='';}
							sendMultipleParamChanged(mshPageId,refObjId,formName, exportType, list);
						};
						
						$WCS_refObj.bind('multiselectChange',function(ui){
							sendParams(ui);
						});
					}
					
					ui._lists.selected.css('height', ui._lists.selected.height()-6);
					ui._lists.available.css('height', ui._lists.available.height()-6);
					
					if (isTransparent=='true'){
						ui._lists.selected.addClass('dcyBgTransparent');
						ui._lists.available.addClass('dcyBgTransparent');
					}
					
					if (ENV_VARS.isOnTouchDevice() && (!ENV_VARS.isOnIosDevice() || ENV_VARS.getIosVersion() !== 8 )) {
						ui._lists.selected.css("-webkit-overflow-scrolling", "touch");
						ui._lists.available.css("-webkit-overflow-scrolling", "touch");
					}
					
				});
}

/**
 *	Init [HorizontalSliderSelector_BaseTMPL] and [VerticalSliderSelector_BaseTMPL] templates. 
 */
function initSliderSelectorTMPL(context,selectedTab, orientation, srcPhoto) {
	
	CSS("css/tabSelector/sliderSelector/elastislide.css"); 
	SCRIPT("jsLib/tabSelector/sliderSelector/modernizr.custom.17475.js");
	SCRIPT("jsLib/tabSelector/sliderSelector/jquery.elastislide.js");
	//importati per il template TabSelector. 
	SCRIPT("jsLib/tabSelector/tabPanel.js");
	SCRIPT("jsLib/tabSelector/tabSelector.js");
	
	var ctx = JSON.parse(context).ctx;
	var tabSelectorId = getCtxValue('refObjId', ctx);   
	var SliderOrientation = orientation; 
	var mainContainerClassName = (SliderOrientation=='vertical') ? 'elastislide-mainContainerV' :'elastislide-mainContainerH';
	var autoSelectTab = selectedTab - 1; // il tabSelctor parte da 1 mentre lo sliderSelector da 0.
	var $elastislideMainContainer = $( '#elastislide-mainContainer'+tabSelectorId );
	var imgHeight = imgWidth = getImgSize(srcPhoto) + 4 ;//size passata dal json nel dato (immagine sempre quadrata) + 4 px di margine.
	
	//default size 128 se non arriva photoUrl
	function getImgSize(photoUrl){
		var defaultSize = 128;
	    var start = photoUrl.indexOf("~S");
		var stop = photoUrl.substring(start).indexOf("&") + start;
		var strSize = photoUrl.substring(start, stop).replace("~S","");
		strSize = (strSize=="")? defaultSize : parseInt(strSize) ;
		return strSize;
	}
	
	//Setta un valore di width proporzionale alla height passata coerente con le dimensioni dell'immagine.
	function setProportionalWidth(height, imgHeight, imgWidth){ 	
		//74 = padding-top + padding-bottom; 20 = padding-left + padding-right;
		if (height < imgHeight + 74){ 
			var nWidth = imgWidth + 20 - (imgHeight + 74 - height);
			$elastislideMainContainer.css('width',nWidth);
		}		
	}

	
	if(SliderOrientation=='vertical'){
		//Vertical slider
		var height = getCtxValue('sliderSelectorAbsoluteHeight', ctx);
		if(typeof(height)!="undefined") {
			//Height in percentuale  prendo le dimensioni della riga che lo contiene e ricavo il valore assoluto proporzionale al valore passato in percentuale.
			//Commentata perchè per ora la proprietà accetta solo valori di height non in percentuale. 
			/*if (height.indexOf("%") != -1 ){
				 var absHeight = parseInt(height.replace("%",""));
				 $( '#OBJ'+tabSelectorId).parent().css('height','100%');//forzo il body della riga al 100%.
				 height = Math.floor( (parseInt($( '#OBJ'+tabSelectorId ).parent().height()) * absHeight) / 100 );		
			} */
			//height assoluta.		
			setProportionalWidth(height, imgHeight, imgWidth);					 
			$elastislideMainContainer.css('height',height);
		}else{//height nulla ==> height = Himg + padding
			$elastislideMainContainer.css('height', imgHeight + 74 );
		} 		
	}else{
		//Horizontal slider
		var width = getCtxValue('min-width', ctx);
		if(typeof(width)!="undefined"){
			//to do --> impostasre sia height che width allo slider selector  
			/*if (width.indexOf("%") != -1 ){// width in percentuale
				//var absWidth = parseInt(width.replace("%",""));
				//width = Math.floor( (parseInt($( '#OBJ'+tabSelectorId).parent().css('width')) * absWidth) / 100 );
			}*/
			$elastislideMainContainer.css('width', width);
		}else{//width nulla ==> width = Wimg + padding
			$elastislideMainContainer.css('width', imgWidth + 74);
		}  
	}
	
	$elastislideMainContainer.addClass(mainContainerClassName);

	$( '#sliderSelector'+tabSelectorId ).elastislide( {
		orientation : SliderOrientation,
		start: autoSelectTab,
		onClick : function( el, position, evt ) { 
					$( "#sliderSelector"+tabSelectorId +" img.elastislide-imgSelected").removeClass("elastislide-imgSelected");
					$(el).children("a").children("img").addClass("elastislide-imgSelected");
		},		
		onReady : function() {
					if(this.orientation === 'vertical'){
					    var $sliderSelector = $('#sliderSelector' + tabSelectorId);
					    var vSliderWidth = $sliderSelector.parent().parent().css('max-width');
					    var vSliderHeight = $sliderSelector.parent().parent().css('height');
					    //set OBJ width and height
					    $("#OBJ"+tabSelectorId).css('min-width', vSliderWidth)
					    					   .css('width',vSliderWidth)
											   .css('min-height', vSliderHeight)
											   .css('height',vSliderHeight);
					    //set OBJ body width and height				
					    $("#OBJ"+tabSelectorId+"_BODY").css('min-width', vSliderWidth)
													   .css('width', vSliderWidth)
													   .css('min-height', vSliderHeight)
													   .css('height', vSliderHeight);											   
					}
	  }
				
	} );
	
	initSliderSelector(tabSelectorId, getCtxValue('tabPanelTarget', ctx), false, getCtxValue('tabFormName', ctx), selectedTab, false);

}
